import React from "react";
import { Icon } from "antd";

export default function KpiCard(props) {
    return (
        <div className="deu-kpi-card">
            <div className="deu-kpi-icon" style={{ backgroundColor: props.iconBackground, color: props.iconColor }}>
                <Icon type={props.icon} />
            </div>
            <div className="deu-kpi-body">
                <div className="deu-kpi-label">{props.label}</div>
                <div className="deu-kpi-value">{props.value}</div>
            </div>
        </div>
    );
}
